import { render } from "./CargoWeightFormula.vue?vue&type=template&id=17da3b47"
import script from "./CargoWeightFormula.vue?vue&type=script&lang=js"
export * from "./CargoWeightFormula.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__